import ePharmaServices from '../services/epharma-services';
import md5 from 'md5';

export default function ConfigService()
{
    const getConfig = async (key: string) =>
    {
        const { base, configuration: configurationUrl } = window.momentaMaisService;
        const response = await ePharmaServices(base).get(`${configurationUrl}/${md5(key)}`);

        return response.data.data;
    }

    return {
        getConfig
    };
}